import qs from 'qs'

export default {
  toObject(obj: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {}

    Object.entries(obj || {}).forEach(([key, value]) => {
      const splittedKey = key.split(/[[\]]/).filter(Boolean)
      if (splittedKey.length > 1) {
        return splittedKey.reduce((acc: Record<string, any>, keyPart: string, currentIndex: number) => {
          if (currentIndex >= splittedKey.length - 1) {
            acc[keyPart] = value
          }
          if (!Reflect.has(acc, keyPart)) {
            acc[keyPart] = {}
          }
          return acc[keyPart]
        }, result)
      }
      result[key] = value
    })

    return result
  },
  toObjectFromQs(string: string): Record<string, any> {
    return qs.parse(string)
  },
  toQueryString(obj: Record<string, any>): string {
    return qs.stringify(obj)
  },
}
